import { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useAuth } from '@/contexts/AuthContext';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';
import { Loader2, KeyRound, User } from 'lucide-react';

export default function PortalMiCuenta() {
  const { perfil } = useAuth();
  const [pwd, setPwd] = useState('');
  const [pwd2, setPwd2] = useState('');
  const [saving, setSaving] = useState(false);

  async function cambiarPassword(e: React.FormEvent) {
    e.preventDefault();
    if (pwd.length < 8) return toast.error('Mínimo 8 caracteres');
    if (pwd !== pwd2) return toast.error('Las contraseñas no coinciden');
    setSaving(true);
    const { error } = await supabase.auth.updateUser({ password: pwd });
    setSaving(false);
    if (error) return toast.error(error.message);
    toast.success('Contraseña actualizada');
    setPwd(''); setPwd2('');
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl md:text-3xl font-bold">Mi cuenta</h1>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="text-base flex items-center gap-2"><User className="h-4 w-4" /> Datos</CardTitle>
        </CardHeader>
        <CardContent className="space-y-2 text-sm">
          <div>
            <p className="text-muted-foreground text-xs">Nombre</p>
            <p className="font-medium">{perfil?.nombre}</p>
          </div>
          <div>
            <p className="text-muted-foreground text-xs">Email</p>
            <p className="font-medium">{perfil?.email}</p>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="text-base flex items-center gap-2"><KeyRound className="h-4 w-4" /> Cambiar contraseña</CardTitle>
        </CardHeader>
        <CardContent>
          <form onSubmit={cambiarPassword} className="space-y-4 max-w-sm">
            <div className="space-y-2">
              <Label htmlFor="pwd">Nueva contraseña</Label>
              <Input id="pwd" type="password" value={pwd} onChange={e => setPwd(e.target.value)} minLength={8} required />
            </div>
            <div className="space-y-2">
              <Label htmlFor="pwd2">Repetir contraseña</Label>
              <Input id="pwd2" type="password" value={pwd2} onChange={e => setPwd2(e.target.value)} minLength={8} required />
            </div>
            <Button type="submit" disabled={saving}>
              {saving && <Loader2 className="h-4 w-4 animate-spin mr-2" />}
              Guardar
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
